import Main from "~/layout/App/Index.vue";

export default {
  path: "/price",
  component: Main,
  meta: {
    breadcrumb: [{ name: "rate.title", route: "price.index" }],
  },
  children: [
    {
      path: "",
      name: "price.index",
      component: () => import("~/views/Price/Index.vue"),
      meta: {
        breadcrumb: [{ name: "breadcrumb.overview" }],
      }
    }
  ]
}; 